
export const INITIAL_STATE = {
	usuario: '',
	nomeLoja: '',
	nomeLojaFormatado: '',
	url: '',
	email: '',
	senha: '',
	cor: '#212429',
	logotipo: "./exemplo.jpg",
	template: '1',
	textoPedidoEntregue: '',
	textoPedidoACaminho: '',
	apoiador: false,
}

export function formReducer(state, action) {
  switch (action.type) {
    case 'HANDLE INPUT': {
      return {
        ...state,
        [action.field]: action.payload,
      };
    }
	case 'HANDLE MULTIPLE INPUTS': {
      return {
		...state,
        ...action.payload,
      };
    }
	default: {
		return INITIAL_STATE;
	}
  }
}

